import React from "react";

function getScrollableParent(
  element: HTMLElement | null,
): HTMLElement | Window {
  let parent = element?.parentElement;

  while (parent) {
    const style = window.getComputedStyle(parent);
    const overflowY = style.overflowY;
    const isScrollable =
      (overflowY === "auto" || overflowY === "scroll") &&
      parent.scrollHeight > parent.clientHeight;

    if (isScrollable) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return window;
}

export function handleSmoothAnchorScroll(
  e: React.MouseEvent<HTMLAnchorElement>,
  offset = 0,
): void {
  const href = e.currentTarget.getAttribute("href");

  if (!href || !href.startsWith("#")) return;

  const target = document.querySelector<HTMLElement>(href);

  if (!target) {
    console.warn(`Smooth scroll target not found: ${href}`);
    return;
  }

  e.preventDefault();

  const scrollParent = getScrollableParent(target);

  if (scrollParent === window) {
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
    return;
  }

  const parentElement = scrollParent as HTMLElement;
  const parentRect = parentElement.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();

  const top =
    parentElement.scrollTop + (targetRect.top - parentRect.top) - offset;

  parentElement.scrollTo({
    top,
    behavior: "smooth",
  });
}
